import { render, staticRenderFns } from "./ReturnToRegistrationConfirmation.vue?vue&type=template&id=053b50b4"
import script from "./ReturnToRegistrationConfirmation.vue?vue&type=script&lang=js"
export * from "./ReturnToRegistrationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports